export default {
    ROOT: "/",
    ENTREPRENEUR_INTERVENTIONS: "/private/entrepreneur/interventions",
    ENTREPRENEUR_SUGGESTIONS: "/private/entrepreneur/suggestions",
    ARTISAN_INTERVENTIONS: "/private/artisan/interventions",
    ENTREPRENEUR_SUGGESTION: "/private/suggestion/:token",
    ARTISAN_EMERGENCY_INTERVENTION: "/private/intervention/emergency/:token",
    ARTISAN_B2C_INTERVENTION: "/private/intervention/b2c/:token",
    BROWSER_AUTH: "/browser/auth",
    ARTISAN_B2CSDU_INTERVENTION: "/private/intervention/b2csdu/:token",
    ARTISAN_INSURANCE_INTERVENTION: "/private/intervention/insurance/:token"
}